import * as React from 'react';
import { MainStyle } from '../assets/styles/MainStyle';
import {TextInput, Text, View} from 'react-native';
import { getSAC, getReg } from '../services/ApiServices';
export default class RegulationFree extends React.Component {
    constructor(props) {
        super(props);
        const styles = MainStyle();
        this.state = {
            redirect: {status: false, value: '/'},
            styles : styles,
            modalOpenend: false,
            regulation: "",
            regulationFormated: [<Text></Text>],
            isLoading: false,
               sac: '99999999999'
        }
    }

    componentDidMount(){

        getSAC().then(res => {this.setState({sac: res})})
        getReg().then(res => {
            res.split("...").map(res => this.state.regulationFormated.push(<Text>{res}</Text>))
            this.setState({regulation: res, regulationFormated : this.state.regulationFormated})
        })
    }

    handleModalOrder(){
        this.setState({modalOpenend : !this.state.modalOpenend})
    }

    render() {
        return (
                <View style={{
                    padding: 24, 
                    width: "100%", 
                    height: "100%", 
                    display: "flex", 
                    flexDirection  : "column",   
                    textAlign: "justify"}}>


                    {/* <TextInput style={{height: 1024, color: "black"}} value={this.state.regulation}></TextInput> */}
                    {this.state.regulationFormated.map(res => res)}

                </View>
            )
    }
}
